import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageReportAction } from '../coverageReport.action';

type IDependencies = ICoverageApiDependencySegment;

export const createCoverageReportEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageReportAction.create.started),
  mergeMap((params) => {
    const { payload, resolve } = params;

    return coverageApi.createCoverageReport(payload.serverId, { name: payload.name }).pipe(
      mergeMap((result) => {
        resolve(result.id);
        return [CoverageReportAction.create.done({ params, result: { reportId: result.id } })];
      }),
      catchApiError((error) => [
        CoverageReportAction.create.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
